'use client';

import { cn } from '@module/lib/utils';
import React from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from '../ui/tooltip';

interface Props {
  children: React.ReactElement<any>;
  content: string | React.ReactNode;
  side?: 'bottom' | 'top' | 'right' | 'left';
  align?: 'center' | 'start' | 'end';
  disabled?: boolean;
  className?: string;
}

export function TooltipBox({
  disabled = false,
  children,
  content,
  side = 'bottom',
  align = 'center',
  className,
}: Props) {
  const [isOpen, setIsOpen] = React.useState(false);
  // tooltip 자체에 disabled 속성이 없으므로 아래 코드로 대체

  return (
    <>
      {disabled ? (
        children
      ) : (
        <Tooltip open={isOpen} onOpenChange={setIsOpen}>
          <TooltipTrigger
            onClick={() => {
              setIsOpen(!isOpen);
            }}
            onMouseEnter={() => {
              setIsOpen(true);
            }}
            asChild
          >
            {children}
          </TooltipTrigger>
          <TooltipContent
            side={side}
            align={align}
            className={cn('z-[30] whitespace-pre-line bg-colorBg_tooltip', className)}
          >
            {content}
          </TooltipContent>
        </Tooltip>
      )}
    </>
  );
}
